import { SwapLine } from '@datanomik/commons-ui/icons';
export const CashPoolingIcon = SwapLine;
